import { PATH_URL } from "@/constants";
import ApiInstance from "./axiosBase";
import { toParams } from "@/utils/ObjectUtils";

export const AdminCreateStore = (body: any) => {
  return ApiInstance.post(`${PATH_URL.STORE}/create`, body);
};

export const AdminCreateCompany = (body: any) => {
  return ApiInstance.post(`${PATH_URL.COMPANY}/create`, body);
};

export const AdminDetailCompany = (id: any) => {
  return ApiInstance.get(`${PATH_URL.COMPANY}/${id}`);
};

export const AdminUpdateCompany = (data: any) => {
  if (!data?.id) return ApiInstance.post(`${PATH_URL.COMPANY}/create`, data);
  return ApiInstance.put(`${PATH_URL.COMPANY}/update/${data.id}`, data);
};

export const AdminGetListStore = (body: {page: number, keyword: string}) => {
  return ApiInstance.get(`${PATH_URL.COMPANY}/list`, {params: body});
}

export const AdminGetListBilling = (body: any) => {
  const params = toParams(body);
  return ApiInstance.get(`${PATH_URL.ADMIN}/billings` + params);
}

export const AdminGetDetailBilling = (id: number) => {
  return ApiInstance.get(`${PATH_URL.ADMIN}/billing/` + id);
}

export const CreatePlan = (body: any) => {
  return ApiInstance.post(`${PATH_URL.COMPANY}/plan/create`, body);
};

export const DetailPlan = (query: any) => {
  const params = toParams(query);
  return ApiInstance.get(`${PATH_URL.COMPANY}/plan` + params);
};

export const DeletePlan = () => {
  return ApiInstance.delete(`${PATH_URL.COMPANY}/plan/delete`);
};

export const UpdatePlanCustomer = (body: any) => {
  return ApiInstance.post(`${PATH_URL.COMPANY}/plan/customer`, body);
};
